import React, { useEffect, useState } from "react";
import {
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Typography,
    Card,
    CardContent,
    Chip,
    Box,
    Grid,
    Divider,
    IconButton,
    Tooltip,
    CircularProgress,
    Fade,
    Zoom,
    Collapse,
    CardHeader,
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Stepper,
    Step,
    StepLabel,
    Breadcrumbs,
    Link,
    Paper,
    Tabs,
    Tab,
    Badge
} from "@material-ui/core";
import {
    Add as AddIcon,
    Check as CheckIcon,
    Clear as ClearIcon,
    GroupWork as GroupWorkIcon,
    Security as SecurityIcon,
    ArrowBack as ArrowBackIcon,
    ExpandMore as ExpandMoreIcon,
    FilterList as FilterListIcon,
    Home as HomeIcon,
    Person as PersonIcon,
    Lock as LockIcon,
    Dashboard as DashboardIcon,
    Settings as SettingsIcon,
    Search as SearchIcon,
    CheckCircle as CheckCircleIcon,
    Info as InfoIcon,
    NavigateNext
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import Notification from "../../components/Notification/Notification";
import {
    assignPermissionToRole,
    fetchRolesWithPermission,
    fetchRolesWithPermissionById,
    getPermission,
    updateRolesandPermission,
} from "../../store/action/permission/permissionAction";
import { createRoles, getRoles, updateRoles } from "../../store/action";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { deleteRoles } from "../../store/action";
import UpdateRoles from "./UpdateRoles";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
        minHeight: "100vh",
        borderRadius: theme.spacing(1),
    },
    header: {
        marginBottom: theme.spacing(4),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(2),
        backgroundColor: "white",
        borderRadius: theme.spacing(2),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    titleContainer: {
        display: "flex",
        flexDirection: "column",
    },
    title: {
        fontWeight: 800,
        color: theme.palette.primary.dark,
        display: "flex",
        alignItems: "center",
        "& svg": {
            marginRight: theme.spacing(2),
            fontSize: "2.2rem",
        },
    },
    subtitle: {
        color: theme.palette.text.secondary,
        fontSize: "1.1rem",
        marginTop: theme.spacing(0.5),
    },
    card: {
        borderRadius: theme.spacing(2),
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
        transition: "transform 0.3s, box-shadow 0.3s",
        border: "1px solid rgba(0, 0, 0, 0.05)",
        "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0 16px 32px rgba(0, 0, 0, 0.1)",
        },
    },
    roleSelectorCard: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(0),
        position: 'relative',
        overflow: 'visible',
    },
    roleCardHeader: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        borderTopLeftRadius: theme.spacing(2),
        borderTopRightRadius: theme.spacing(2),
        padding: theme.spacing(2),
    },
    selectedRoleBadge: {
        position: 'absolute',
        top: -10,
        right: 20,
        backgroundColor: theme.palette.success.main,
        color: 'white',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(0.5, 2),
        fontSize: '0.75rem',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        zIndex: 1,
    },
    selectedPermissionsCard: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(0),
        background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
        color: "white",
        border: "none",
    },
    permissionCardHeader: {
        padding: theme.spacing(2),
        borderBottom: `1px solid rgba(255, 255, 255, 0.1)`,
    },
    permissionGroupCard: {
        marginBottom: theme.spacing(3),
        borderLeft: `4px solid ${theme.palette.primary.main}`,
    },
    groupHeader: {
        backgroundColor: theme.palette.grey[50],
        padding: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    permissionButton: {
        borderRadius: theme.spacing(4),
        textTransform: "none",
        fontWeight: 600,
        margin: theme.spacing(0.5),
        padding: theme.spacing(1, 2),
        transition: "all 0.2s",
        "&.selected": {
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
            transform: "scale(1.05)",
        },
        "&:hover": {
            transform: "scale(1.05)",
        },
    },
    actionButtons: {
        marginTop: theme.spacing(4),
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
        padding: theme.spacing(3),
        backgroundColor: "white",
        borderRadius: theme.spacing(2),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    chipContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        padding: theme.spacing(0, 2, 2, 2),
    },
    groupActions: {
        display: "flex",
        gap: theme.spacing(1),
    },
    loadingSpinner: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    emptyState: {
        textAlign: "center",
        padding: theme.spacing(4),
        color: theme.palette.text.secondary,
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: theme.spacing(5),
        height: theme.spacing(5),
    },
    breadcrumbs: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        backgroundColor: 'white',
        borderRadius: theme.spacing(2),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    stepContainer: {
        padding: theme.spacing(3),
        backgroundColor: "white",
        borderRadius: theme.spacing(2),
        marginBottom: theme.spacing(3),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    stepIcon: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        borderRadius: '50%',
        width: 28,
        height: 28,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.9rem',
        fontWeight: 'bold',
    },
    statusIndicator: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(2),
        borderRadius: theme.spacing(2),
        backgroundColor: theme.palette.info.light,
        color: theme.palette.info.dark,
        marginBottom: theme.spacing(3),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    progressBar: {
        width: '100%',
        height: 10,
        backgroundColor: theme.palette.grey[200],
        borderRadius: 5,
        overflow: 'hidden',
        marginTop: theme.spacing(1),
    },
    progressFill: {
        height: '100%',
        background: `linear-gradient(90deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
        transition: 'width 0.5s ease',
        borderRadius: 5,
    },
    searchBox: {
        padding: theme.spacing(2),
        backgroundColor: "white",
        borderRadius: theme.spacing(2),
        marginBottom: theme.spacing(3),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    tabContainer: {
        // marginBottom: theme.spacing(3),
        backgroundColor: "white",
        borderRadius: theme.spacing(2),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    tab: {
        minWidth: 120,
        fontWeight: 600,
    },
    roleItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(1, 0),
        borderBottom: "1px solid #f0f0f0",
        "&:last-child": {
            borderBottom: "none",
        },
    },
    roleActionButtons: {
        opacity: 0.7,
        transition: "opacity 0.2s",
        "&:hover": {
            opacity: 1,
        },
    },
    createRoleForm: {
        padding: theme.spacing(3),
        backgroundColor: "white",
        borderRadius: theme.spacing(2),
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        marginBottom: theme.spacing(3),
    },
    errorAlert: {
        padding: '16px',
        marginBottom: '24px',
        backgroundColor: '#ffebee',
        color: '#c62828',
        borderRadius: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
}));

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
        backgroundColor: theme.palette.success.main,
    },
}))(Badge);

const steps = ['Create Role', 'Assign Permissions', 'Review & Save'];

const CreateRoles = ({ match, history }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const ID = match?.params?.id;
    const [activeStep, setActiveStep] = useState(ID ? 0 : 0);
    const [searchQuery, setSearchQuery] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const [stepError, setStepError] = useState(""); // Add this state for step errors

    const {
        roleswithPermissionError,
        roleswithPermissionSuccess,
        getPermissionItem,
        loading,
        fetchRolespermission
    } = useSelector((state) => state.permission);

    const { getRolesItem, rolesLoading, roleSuccess, roleErrors } = useSelector((state) => state.roles);

    const [permissionList, setPermissionList] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [permissionError, setPermissionError] = useState(false);
    const [roleError, setRoleError] = useState(false);
    const [notificationVisible, setNotificationVisible] = useState(false);
    const [expandedGroups, setExpandedGroups] = useState({});
    const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

    useEffect(() => {
        if (ID) {
            dispatch(fetchRolesWithPermissionById(ID));
        }
    }, [ID]);

    useEffect(() => {
        if (ID) {
            if (fetchRolespermission?.data) {
                const roleObject = getRolesItem?.data?.find(
                    (role) => role.name === fetchRolespermission.data.role?.name
                );
                if (roleObject) {
                    console.log("i am 1");
                    setSelectedRole(roleObject.id);
                    setActiveStep(0);
                }
                const selectedPermObjects = fetchRolespermission?.data?.permission ?? [];
                setSelectedPermissions(selectedPermObjects);
            }
        }
    }, [fetchRolespermission, getRolesItem, ID]);

    useEffect(() => {
        dispatch(getRoles());
        dispatch(getPermission());
        if (!ID) {
            console.log("i am 2");
            setSelectedRole("");
            setSelectedPermissions([]);
        }
    }, [dispatch, ID]);

    useEffect(() => {
        if (getPermissionItem?.data?.length > 0) {
            setPermissionList(getPermissionItem.data);
            const expanded = {};
            getPermissionItem.data.forEach((group, index) => {
                expanded[index] = true;
            });
            setExpandedGroups(expanded);
        }
    }, [getPermissionItem]);

    // Calculate total progress
    const totalPermissions = permissionList.reduce((total, group) =>
        total + group.permissions.split(",").length, 0
    );
    const progressPercentage = totalPermissions > 0 ?
        (selectedPermissions.length / totalPermissions) * 100 : 0;

    const toggleGroup = (index) => {
        setExpandedGroups(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const handlePermissionToggle = (permId) => {
        const id = Number(permId);
        setSelectedPermissions((prev) =>
            prev.includes(id)
                ? prev.filter((existingId) => existingId !== id)
                : [...prev, id]
        );
        setPermissionError(false);
        setStepError(""); // Clear error when user interacts
    };

    const handleSelectAll = (permissionsInGroup, index) => {
        const ids = permissionsInGroup.map((perm) => Number(perm.split(":")[0]));
        setSelectedPermissions((prev) => {
            const newSelection = [...prev];
            ids.forEach((id) => {
                if (!newSelection.includes(id)) newSelection.push(id);
            });
            return newSelection;
        });
        if (!expandedGroups[index]) {
            toggleGroup(index);
        }
        setPermissionError(false);
        setStepError(""); // Clear error when user interacts
    };

    const handleDeselectAll = (permissionsInGroup) => {
        const ids = permissionsInGroup.map((perm) => Number(perm.split(":")[0]));
        setSelectedPermissions((prev) =>
            prev.filter((id) => !ids.includes(id))
        );
        setPermissionError(false);
        setStepError(""); // Clear error when user interacts
    };

    const handleClearAll = () => {
        setData({ name: "" });
        setSelectedPermissions([]);
        console.log("i am 3");
        setSelectedRole("");
        setPermissionError(false);
        setRoleError(false);
        setActiveStep(0);
        setStepError(""); // Clear error when resetting
    };

    const handleNext = () => {
        if (activeStep === 0 && !data.name) {
            setRoleError(true);
            setStepError("Please enter a role name");
            return;
        }
        if (activeStep === 1 && selectedPermissions.length === 0) {
            setPermissionError(true);
            setStepError("Please select at least one permission");
            return;
        }
        setStepError(""); // Clear any previous errors
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setSelectedPermissions([]);
        setSelectedRole("");
        history.goBack('/admin/roles');
        // setActiveStep((prev) => prev - 1);
        setStepError(""); // Clear error when going back
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let hasErrors = false;

        if (!selectedRole) {
            setRoleError(true);
            setStepError("Please select a role");
            hasErrors = true;
        }
        if (selectedPermissions.length === 0) {
            setPermissionError(true);
            setStepError("Please select at least one permission");
            hasErrors = true;
        }

        if (hasErrors) return;

        if (ID) {
            const updatedData = {
                role_id: ID,
                roles: selectedRole,
                permission: selectedPermissions,
            };
            try {
                dispatch(updateRolesandPermission(updatedData));
                setNotificationVisible(true);
                selectedRolename("");
                setSelectedRole("");
                setSelectedPermissions([]);

            } catch (err) {
                console.log(err);
            }
        } else {
            const payload = {
                roles: selectedRole,
                permission: selectedPermissions,
            };
            dispatch(assignPermissionToRole(payload));
            setNotificationVisible(true);
            console.log("i am 5");
            setSelectedRole("");
            selectedRolename("");
            setSelectedPermissions([]);
        }
        // dispatch(fetchRolesWithPermission());
        if (loginUserInfo?.role != "SUPERADMIN") {
            history.push("/admin/roles");
        } else {
            history.push("/super-admin/roles");
        }

    };

    const [open, setOpen] = useState(false);
    const [formError, setError] = useState([]);

    const closeModal = () => {
        setOpen(false);
        setRoleError(false);
        setPermissionError(false);
        setStepError(""); // Clear error when closing modal
    }

    const handleDialogClose = () => {
        setOpen(false);
        setRoleError(false);
        setPermissionError(false);
        setStepError(""); // Clear error when closing modal
    }

    const onSubmitRoles = async (event) => {
        event.preventDefault();
        if (data.name === "") {
            setError('err_role_name');
            setStepError("Please enter a role name");
            return; // Don't proceed if there's an error
        } else {
            try {
                console.log(roleId, "roleId");
                await dispatch(createRoles(data));
                if (roleId == null || roleId == "") {
                    setSelectedPermissions([]);
                }
                setData({ name: "" });
                // Check if the result contains an error
                if (roleErrors?.message) {
                    console.error("Error creating role:", roleErrors.message);
                    setActiveStep(0);
                    return; // Don't proceed if there's an error
                }
                setTimeout(() => {
                    dispatch(getRoles());
                    setActiveStep(1);
                }, [3000]);
                setStepError(""); // Clear any errors
            } catch (error) {
                console.error("Error creating role:", error);
                setStepError("Error creating role");
            }
        }
    };
    const [rolename, selectedRolename] = useState("");
    useEffect(() => {
        if (roleSuccess?.data?.id) {
            setSelectedRole(roleSuccess?.data?.id);
            selectedRolename(roleSuccess?.data?.name);
        }
    }, [roleSuccess?.data?.id]);

    const handleChange = (event) => {
        if (event.target.value) {
            setError([]);
            setStepError(""); // Clear error when user types
        } else {
            setError('err_role_name');
        }
        setData({ ...data, [event.target.name]: event.target.value });
    };

    const [data, setData] = useState({
        name: "",
    });

    const handleDeleteRole = (id) => {
        dispatch(deleteRoles(id));
        dispatch(getRoles());
        history.push("/admin/roles");
    }

    // Filter permissions based on search query
    const filteredPermissionList = permissionList.filter(group =>
        group.module.toLowerCase().includes(searchQuery.toLowerCase()) ||
        group.permissions.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const [roleId, setRoleId] = useState("");
    useEffect(() => {
        if (roleId) {
            dispatch(fetchRolesWithPermissionById(roleId));
        }
    }, [roleId, dispatch]);

    useEffect(() => {
        if (fetchRolespermission?.data?.permission) {
            setSelectedPermissions(fetchRolespermission.data.permission);
        }
    }, [fetchRolespermission]);
    const handleRoleChange = (event) => {
        setRoleId(event.target.value);
        if (event.target.value) {
            setRoleError(false);
            setStepError(""); // Clear error when selecting a role
            // setActiveStep(1);
        }
    };
    // Show role creation errors in the current step
    useEffect(() => {
        if (roleErrors?.message && activeStep === 0) {
            setStepError(roleErrors.message);
        }
    }, [roleErrors, activeStep]);
    const updateRole = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const formValues = Object.fromEntries(formData.entries());
        dispatch(updateRoles(formValues));
        setOpen(false);
    }

    const EditRole = () => {
        console.log(rolename, "1");
        console.log(fetchRolespermission?.data?.role?.name, "2");

        setOpen(true);
        setData({ name: rolename || fetchRolespermission?.data?.role?.name })
    }
    // const [open, setOpen] = useState(false);
    return (
        <>
            {/* Notifications - Keep these for global errors */}
            {roleSuccess?.message && (
                <Notification
                    data={roleSuccess?.message}
                    status="success"
                />
            )}
            {roleErrors?.message && (
                <Notification
                    data={roleErrors?.message}
                    status="error"
                />
            )}
            {roleswithPermissionError?.message && (
                <Notification
                    data={roleswithPermissionError?.message}
                    status="error"
                />
            )}
            {roleswithPermissionSuccess?.message && (
                <Notification
                    data={roleswithPermissionSuccess?.message}
                    status="success"
                />
            )}

            <div className={classes.root}>
                {/* Header */}
                <div className={classes.header}>
                    <div className={classes.titleContainer}>
                        <Typography variant="h4" className={classes.title}>
                            <SecurityIcon />
                            Role Permissions Manager
                        </Typography>
                        <Typography variant="body1" className={classes.subtitle}>
                            {ID ? 'Edit permissions for existing role' : 'Create a new role and assign permissions'}
                        </Typography>
                    </div>
                    <div>
                        <Tooltip title="Go back">
                            <IconButton onClick={() => history.goBack()} style={{ marginRight: 8 }}>
                                <ArrowBackIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Clear all selections">
                            <Button
                                variant="outlined"
                                color="default"
                                onClick={handleClearAll}
                                startIcon={<ClearIcon />}
                            >
                                Reset
                            </Button>
                        </Tooltip>
                    </div>
                </div>

                {/* Stepper - Only show when creating a new role */}
                {!ID && (
                    <Paper className={classes.stepContainer}>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel
                                        StepIconComponent={() => (
                                            <div className={classes.stepIcon}>
                                                {index + 1}
                                            </div>
                                        )}
                                    >
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Paper>
                )}

                {/* Step Error Display */}
                {/* {stepError && (
                    <Paper className={classes.errorAlert}>
                        <Box display="flex" alignItems="center">
                            <ClearIcon style={{ marginRight: '8px' }} />
                            <Typography variant="body2">
                                {stepError}
                            </Typography>
                        </Box>
                    </Paper>
                )} */}

                {/* Status Indicator */}
                <Paper className={classes.statusIndicator}>
                    {selectedRole || ID ? (
                        <>
                            <CheckCircleIcon color="success" />
                            <Typography variant="body2">
                                {ID ? 'Editing' : 'Creating'}: <strong>{ID ? getRolesItem?.data?.find(r => r.id === ID)?.name : data.name}</strong>
                                {selectedPermissions.length > 0 && (
                                    <> - {selectedPermissions.length} permission(s) selected</>
                                )}
                            </Typography>
                        </>
                    ) : (
                        <>
                            <InfoIcon color="info" />
                            <Typography variant="body2">
                                {activeStep === 0 ? 'Create a new role to begin' : 'Select a role to begin assigning permissions'}
                            </Typography>
                        </>
                    )}
                </Paper>

                {/* Progress Bar - Only show when a role is selected */}
                {(selectedRole || ID) && (
                    <Paper style={{ padding: '16px', marginBottom: '24px' }}>
                        <Typography variant="body2" gutterBottom>
                            Permissions assigned: {selectedPermissions.length} of {totalPermissions}
                            ({Math.round(progressPercentage)}%)
                        </Typography>
                        <div className={classes.progressBar}>
                            <div
                                className={classes.progressFill}
                                style={{ width: `${progressPercentage}%` }}
                            />
                        </div>
                    </Paper>
                )}

                <Grid container spacing={3}>
                    {/* Role Creation/Selection Section */}
                    {activeStep === 0 && !ID && (
                        <form onSubmit={onSubmitRoles} style={{ width: "100%" }}>
                            <Grid container spacing={3}>
                                {/* Row 1 - Two Cards side by side */}
                                <Grid item xs={12} md={6}>
                                    <Card className={classes.createRoleForm} sx={{ height: '100%' }}>
                                        <CardHeader
                                            title="Step 1: Create New Role"
                                            subheader="Enter a unique name for your new role"
                                            titleTypographyProps={{ variant: "h6", color: "primary" }}
                                            subheaderTypographyProps={{ variant: "body2" }}
                                        />
                                        <Divider />
                                        <CardContent sx={{ pt: 3 }}>
                                            <FormControl
                                                variant="outlined"
                                                fullWidth
                                                error={formError.includes('err_role_name')}
                                            >
                                                <TextField
                                                    id="role_name"
                                                    name="name"
                                                    label="Role Name"
                                                    variant="outlined"
                                                    value={data.name || ""}
                                                    fullWidth
                                                    placeholder="e.g., Content Moderator, Support Agent"
                                                    error={formError.includes('err_role_name')}
                                                    helperText={
                                                        formError.includes('err_role_name')
                                                            ? "Please enter a role name"
                                                            : "This will be the display name for the role"
                                                    }
                                                    onChange={handleChange}
                                                    autoFocus
                                                    sx={{ mb: 1 }}
                                                />
                                            </FormControl>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card className={classes.createRoleForm} sx={{ height: '100%' }}>
                                        <CardHeader
                                            title="Clone Permissions (Optional)"
                                            subheader="Copy permissions from an existing role"
                                            titleTypographyProps={{ variant: "h6", color: "primary" }}
                                            subheaderTypographyProps={{ variant: "body2" }}
                                        />
                                        <Divider />
                                        <CardContent sx={{ pt: 3 }}>
                                            <FormControl variant="outlined" fullWidth error={roleError}>
                                                <InputLabel id="clone-role-label">Select Role to Clone</InputLabel>
                                                <Select
                                                    value={roleId}
                                                    onChange={handleRoleChange}
                                                    label="Select Role to Clone"
                                                    labelId="clone-role-label"
                                                    disabled={loginUserInfo?.role === "SUPERADMIN"}
                                                    sx={{ mb: 1 }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None - Start with blank permissions</em>
                                                    </MenuItem>

                                                    {getRolesItem?.data?.map((role) => (
                                                        <MenuItem key={role.id} value={role.id}>
                                                            <Box
                                                                display="flex"
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                                width="100%"
                                                            >
                                                                <Typography variant="body2">{role.name}</Typography>
                                                            </Box>
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText sx={{ mx: 0 }}>
                                                    {loginUserInfo?.role === "SUPERADMIN"
                                                        ? "Super admins cannot clone roles"
                                                        : "Select a role to copy its permissions structure"}
                                                </FormHelperText>
                                            </FormControl>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Row 2 - Button */}
                                <Grid item xs={12}>
                                    <Box mt={2} display="flex" justifyContent="flex-end">
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            disabled={!data.name}
                                            sx={{ minWidth: 200 }}
                                        >
                                            Create Role & Continue
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>

                    )}

                    {/* Permissions Section - Show when role is created/selected */}
                    {(activeStep >= 1 || ID) && (
                        <Grid item xs={12}>
                            <Grid
                                className={classes.tabContainer}
                                container
                                spacing={2}
                            >
                                {/* Search Box */}
                                <Grid item xs={6}>

                                    <Paper className={`${classes.searchBox} p-2 flex items-center`} style={{ flex: 1 }}>
                                        <SearchIcon color="action" className="mr-2" />
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Search permissions..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            size="small"
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={6}>
                                    {/* Role Selection */}
                                    <Paper className="p-3" style={{ flex: 1 }}>
                                        <FormControl variant="outlined" fullWidth error={roleError}>
                                            {!open && (
                                                <>
                                                    {/* <InputLabel>Role Name</InputLabel>
                                                    <Select
                                                        value={Number(selectedRole)}
                                                        onChange={handleRoleChange}
                                                        label="Role"
                                                        disabled={true}
                                                    >
                                                        <MenuItem value="">
                                                            <em>Select a role</em>
                                                        </MenuItem>

                                                        {getRolesItem?.data?.filter((item) => item?.role_name !== "SUPERADMIN").map((role) => (
                                                            <MenuItem key={role.id} value={role.id}>
                                                                <div className="flex justify-between items-center w-full">
                                                                    <span>{role.name}</span>
                                                                </div>
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    <Button onClick={() => EditRole()}>Edit role</Button> */}
                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        <FormControl variant="outlined" fullWidth disabled={true}>
                                                            <InputLabel>Role</InputLabel>
                                                            <Select
                                                                value={Number(selectedRole)}
                                                                label="Role"
                                                            >
                                                                <MenuItem value="">
                                                                    <em>Select a role</em>
                                                                </MenuItem>
                                                                {getRolesItem?.data?.filter((item) => item?.role_name !== "SUPERADMIN").map((role) => (
                                                                    <MenuItem key={role.id} value={role.id}>
                                                                        {role.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>

                                                        <Button
                                                            onClick={() => EditRole()}
                                                            color="primary"
                                                            size="small"
                                                            startIcon={<EditIcon />}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </Box>
                                                </>
                                            )}
                                            {open && (
                                                <>
                                                    <form onSubmit={updateRole}>
                                                        <Box display="flex" flexDirection="column" gap={2} p={2}>
                                                            <FormControl variant="outlined" fullWidth error={formError.includes('err_role_name')}>
                                                                <input type="hidden" name="id" value={selectedRole} />
                                                                <TextField
                                                                    id="role_name"
                                                                    name="name"
                                                                    label="Role Name"
                                                                    variant="outlined"
                                                                    value={data?.name || ""}
                                                                    fullWidth
                                                                    placeholder="e.g., Content Moderator, Support Agent"
                                                                    error={formError.includes('err_role_name')}
                                                                    helperText={
                                                                        formError.includes('err_role_name')
                                                                            ? "Role name is required"
                                                                            : "Enter a descriptive name for this role"
                                                                    }
                                                                    onChange={handleChange}
                                                                    autoFocus
                                                                />
                                                            </FormControl>

                                                            <Box display="flex" justifyContent="flex-end" gap={3}>
                                                                <Button
                                                                    style={{ marginRight: "10ppx" }}
                                                                    variant="outlined"
                                                                    color="default"
                                                                    size="small"
                                                                    onClick={() => setOpen(false)}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                                <Button
                                                                    type="submit"
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                    disabled={!data?.name || data.name.trim() === ""}
                                                                    startIcon={<CheckIcon />}
                                                                >
                                                                    Update Role
                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                    </form>
                                                </>
                                            )}
                                        </FormControl>
                                    </Paper>
                                </Grid>
                            </Grid>


                            {/* Permission Groups */}
                            {loading ? (
                                <div className={classes.loadingSpinner}>
                                    <CircularProgress />
                                    <Typography variant="body2" color="textSecondary">
                                        Loading permissions...
                                    </Typography>
                                </div>
                            ) : filteredPermissionList.length > 0 ? (
                                filteredPermissionList.map((group, idx) => {
                                    const permissions = group.permissions.split(",");
                                    const groupPermissionsSelected = permissions.filter(perm => {
                                        const id = perm.split(":")[0];
                                        return selectedPermissions.includes(Number(id));
                                    }).length;

                                    // Skip group if we're in "Selected Only" tab and no permissions are selected
                                    if (activeTab === 1 && groupPermissionsSelected === 0) {
                                        return null;

                                    }

                                    return (
                                        <Card key={idx} className={`${classes.card} ${classes.permissionGroupCard}`}>
                                            <CardHeader
                                                avatar={
                                                    <Avatar style={{ backgroundColor: `hsl(${idx * 45}, 70%, 50%)` }}>
                                                        {group.module.charAt(0).toUpperCase()}
                                                    </Avatar>
                                                }
                                                title={
                                                    <Box display="flex" alignItems="center">
                                                        <Typography variant="h6">
                                                            {group.module}
                                                        </Typography>
                                                        <Typography variant="caption" style={{ marginLeft: 8 }}>
                                                            ({groupPermissionsSelected} of {permissions.length} selected)
                                                        </Typography>
                                                    </Box>
                                                }
                                                subheader={`Permissions for ${group.module} module`}
                                                action={
                                                    <div className={classes.groupActions}>
                                                        <Button
                                                            size="small"
                                                            color="primary"
                                                            onClick={() => handleSelectAll(permissions, idx)}
                                                            startIcon={<CheckIcon />}
                                                            disabled={groupPermissionsSelected === permissions.length}
                                                            variant="outlined"
                                                        >
                                                            Select All
                                                        </Button>
                                                        <Button
                                                            size="small"
                                                            color="default"
                                                            onClick={() => handleDeselectAll(permissions)}
                                                            disabled={groupPermissionsSelected === 0}
                                                            variant="outlined"
                                                        >
                                                            Deselect All
                                                        </Button>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => toggleGroup(idx)}
                                                        >
                                                            <ExpandMoreIcon style={{
                                                                transform: expandedGroups[idx] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                transition: 'transform 0.3s'
                                                            }} />
                                                        </IconButton>
                                                    </div>
                                                }
                                            />

                                            <Collapse in={expandedGroups[idx]} timeout="auto" unmountOnExit>
                                                <Divider />
                                                <CardContent>
                                                    <Box display="flex" flexWrap="wrap">
                                                        {permissions.map((perm) => {
                                                            const [id, name] = perm.split(":");
                                                            const IDS = Number(id);
                                                            const isSelected = selectedPermissions.includes(IDS);
                                                            return (
                                                                <Tooltip key={id} title={name} placement="top">
                                                                    <Button
                                                                        variant={isSelected ? "contained" : "outlined"}
                                                                        color={isSelected ? "secondary" : "primary"}
                                                                        size="small"
                                                                        className={`${classes.permissionButton} ${isSelected ? 'selected' : ''}`}
                                                                        onClick={() => handlePermissionToggle(id)}
                                                                        startIcon={isSelected ? <CheckIcon /> : null}
                                                                    >
                                                                        {name}
                                                                    </Button>
                                                                </Tooltip>
                                                            );
                                                        })}
                                                    </Box>
                                                </CardContent>
                                            </Collapse>
                                        </Card>
                                    );
                                })
                            ) : (
                                <Card className={classes.card}>
                                    <div className={classes.emptyState}>
                                        <FilterListIcon style={{ fontSize: 48, color: '#ddd' }} />
                                        <Typography variant="h6" color="textSecondary">
                                            No permission groups available
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                                            {searchQuery ? 'No results found for your search' : 'Permission groups will appear here once loaded'}
                                        </Typography>
                                    </div>
                                </Card>
                            )}
                        </Grid>
                    )}
                </Grid>

                {/* Navigation Buttons */}
                <div className={selectedRole ? classes.actionButtons : ""}>
                    {selectedRole && <Button
                        variant="outlined"
                        color="default"
                        onClick={handleBack}
                        size="large"
                        startIcon={<ArrowBackIcon />}
                    >
                        {activeStep === 0 ? 'Cancel' : 'Back'}
                    </Button>}

                    {activeStep === steps.length - 1 || ID ? (
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleSubmit}
                            size="large"
                            startIcon={<CheckIcon />}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} /> : ID ? 'Update Permissions' : 'Save Permissions'}
                        </Button>
                    ) : selectedRole ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            size="large"
                            endIcon={<CheckIcon />}
                        >
                            Next: Review & Save
                        </Button>
                    ) : null}
                </div>
            </div>
        </>
    );
};

export default CreateRoles;